export default __webpack_public_path__ + "2eea2a36236bebe7212498e19de6570d.png";